import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { WhatsAppNewClientComponent } from './whats-app-new-client.component';
import { HttpClientModule } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  declarations: [WhatsAppNewClientComponent],
  exports: [WhatsAppNewClientComponent],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    MarkdownModule.forChild(),
    RouterModule.forChild([
      { path: '', component: WhatsAppNewClientComponent }
    ])
  ]
})
export class WhatsAppNewClientModule { }
